import { createSlice } from "@reduxjs/toolkit";

const accountSlice = createSlice({
  name: "account",
  initialState: {},
  reducers: {
    accountAdded(state, action) {
      return action.payload;
    },
    accountVerified(state) {
      return { ...state, verified: true };
    },
    // The fields "Account verwalten" saved, as the server stored them
    accountUpdated(state, action) {
      return { ...state, ...action.payload };
    },
  },
});

export const { accountAdded, accountVerified, accountUpdated } = accountSlice.actions;
export default accountSlice.reducer;
